export default function initContactLink() {
  const button = document.getElementById("get-in-touch");
  if (!button) return;

  button.addEventListener("click", () => {
    const address = ["ivtoskov", "gmail.com"].join("@");
    window.location.href = `mailto:${address}`;
  });
}
